import React from 'react';
import { Paragraph5 } from '@r1-frontend/ui-react/components/typography/paragraph';
export var PolicyNote = function (_a) {
    var agreeUrl = _a.agreeUrl, _b = _a.buttonText, buttonText = _b === void 0 ? 'Отправить' : _b, _c = _a.urlTextGenitive, urlTextGenitive = _c === void 0 ? 'Условиями обработки данных' : _c, children = _a.children;
    return (<Paragraph5>
            Нажимая «{buttonText}», вы соглашаетесь с&nbsp;
            <a href={agreeUrl} target='_blank' rel='noreferrer nofollow noopener' data-test={'linkAgree'}>
                <b>{urlTextGenitive}</b>
            </a>
            {children}
        </Paragraph5>);
};
